<script setup lang="ts">
import { getSuggestionCategory, getSuggestionStatus } from '~~/shared/utils/suggestions'

interface Props {
  category: string
  status: string
  /** Show the status even when it is the default "Open". */
  showOpen?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showOpen: false
})

const categoryMeta = computed(() => getSuggestionCategory(props.category))
const statusMeta = computed(() => getSuggestionStatus(props.status))
</script>

<template>
  <div class="flex flex-wrap items-center gap-1.5">
    <UBadge
      v-if="showOpen || statusMeta.value !== 'open'"
      :label="statusMeta.label"
      :icon="statusMeta.icon"
      :color="statusMeta.color"
      variant="subtle"
      size="sm"
    />
    <UBadge
      :label="categoryMeta.label"
      :icon="categoryMeta.icon"
      color="neutral"
      variant="outline"
      size="sm"
    />
  </div>
</template>
